<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-kingdom-of-wannasea-1">
<h1>The Kingdom of Wannasea</h1>
<p style="text-indent: 00em;">The Reginalds were a most devious lot</p>
<p style="text-indent: 00em;">self-proclaimed kings and good-for-naughts</p>
<p style="text-indent: 00em;">Nine the worst of that dastardly crew</p>
<p style="text-indent: 00em;">charging dearly for water the islanders drew</p>
<p style="text-indent: 00em;">menaced by mercenaries common and crude</p>
<p style="text-indent: 00em;">pushing the populace into virtual servitude</p><br/>
<p style="text-indent: 00em;">Oh, Isle of Wannasea</p>
<p style="text-indent: 00em;">ever may your skies be blue</p>
<p style="text-indent: 00em;">ever may your worries be few</p>
<p style="text-indent: 00em;">forever your people free</p><br/>
<p style="text-indent: 00em;">Nine’s plans moved along nicely until Theo died</p>
<p style="text-indent: 00em;">buried by a falling wall and resulting landslide</p>
<p style="text-indent: 00em;">but no never mind, Hugo would suffice as Ten</p>
<p style="text-indent: 00em;">with duplicitous Sylvester in control of Nine’s men</p>
<p style="text-indent: 00em;">On an island brimming with pent up hate</p>
<p style="text-indent: 00em;">Nine sensed the time had come to abdicate</p><br/>
<p style="text-indent: 00em;">Hugo followed Nine in every islander’s mind</p>
<p style="text-indent: 00em;">to Nine’s machinations remaining fully blind</p>
<p style="text-indent: 00em;">Sylvester would gather what was to be collected</p>
<p style="text-indent: 00em;">Hugo soon enough be whom the islanders rejected</p>
<p style="text-indent: 00em;">No matter how distracted this sky-minded son</p>
<p style="text-indent: 00em;">Nine would continue the profit from his thirty year run</p><br/>
<p style="text-indent: 00em;">Oh, Isle of Wannasea</p>
<p style="text-indent: 00em;">ever may your skies be blue</p>
<p style="text-indent: 00em;">ever may your worries be few</p>
<p style="text-indent: 00em;">forever your people free</p><br/>
<p style="text-indent: 00em;">Hugo even with a head always in the clouds</p>
<p style="text-indent: 00em;">sensed rising anger among within milling crowds</p>
<p style="text-indent: 00em;">Alice, the love of young Hugo’s life</p>
<p style="text-indent: 00em;">spoke of a plan to end their island’s strife</p>
<p style="text-indent: 00em;">Hugo was indeed to follow Nine as Ten</p>
<p style="text-indent: 00em;">but Wannasea no longer would be ruled by evil men</p><br/>
<p style="text-indent: 00em;">Oh, Isle of Wannasea</p>
<p style="text-indent: 00em;">ever may your skies be blue</p>
<p style="text-indent: 00em;">ever may your worries be few</p>
<p style="text-indent: 00em;">forever your people free</p>
<p style="text-indent: 00em;">with the downfall of kings on Wannasea</p><br/>
<p style="text-indent: 00em;">Hugo succeeded Nine as Wannasea’s king</p>
<p style="text-indent: 00em;">Soon began moving like he was on a string</p>
<p style="text-indent: 00em;">believing Sylvester had Hugo under his thumb</p>
<p style="text-indent: 00em;">Nine sailed off south with a magnificent sum</p>
<p style="text-indent: 00em;">all while Alice filled Mainland agents’ eyes</p>
<p style="text-indent: 00em;">with documents and drawings Hugo supplied</p><br/>
<p style="text-indent: 00em;">Oh, Isle of Wannasea</p>
<p style="text-indent: 00em;">ever may your skies be blue</p>
<p style="text-indent: 00em;">ever may your worries be few</p>
<p style="text-indent: 00em;">forever your people free</p>
<p style="text-indent: 00em;">with the downfall of kings on Wannasea</p><br/>
<p style="text-indent: 00em;">In deepest dark, the second night Nine was gone</p>
<p style="text-indent: 00em;">three large Mainland ships to the harbor were drawn</p>
<p style="text-indent: 00em;">without one single shot being fired</p>
<p style="text-indent: 00em;">Sylvester and his men were bound, gagged and retired</p>
<p style="text-indent: 00em;">the battle turning into a struggle of nerves</p>
<p style="text-indent: 00em;">’til the Mainlanders drained Nine’s cash reserves</p><br/>
<p style="text-indent: 00em;">Praise be to the bright stars above</p>
<p style="text-indent: 00em;">shining down on this island we so love</p>
<p style="text-indent: 00em;">Praise be to Wannasea Mountain so high</p>
<p style="text-indent: 00em;">where freedom must keep a watchful eye</p><br/>
<p style="text-indent: 00em;">Lakes and castle under civilian rule</p>
<p style="text-indent: 00em;">Hugo and Alice, off the island they flew</p>
<p style="text-indent: 00em;">Hugo to flight training at Mainland’s largest base</p>
<p style="text-indent: 00em;">Alice to attend college at a nearby place</p>
<p style="text-indent: 00em;">Faced with the outcome, Nine’s ire was legend</p>
<p style="text-indent: 00em;">Alice and Hugo with vile acts were threatened</p><br/>
<p style="text-indent: 00em;">Oh, Isle of Wannasea</p>
<p style="text-indent: 00em;">ever may your skies be blue</p>
<p style="text-indent: 00em;">ever may your worries be few</p>
<p style="text-indent: 00em;">forever your people free</p>
<p style="text-indent: 00em;">after the downfall of kings on Wannasea</p><br/>
<p style="text-indent: 00em;">Praise be</p>
<p style="text-indent: 00em;">for pure rain which falls</p>
<p style="text-indent: 00em;">midst storms and summer squalls</p>
<p style="text-indent: 00em;">Praise be</p>
<p style="text-indent: 00em;">to this strange island known as Wannasea</p>
<p style="text-indent: 00em;">where always and ever we long to be</p>
<p style="text-indent: 00em;">Praise be</p>
<p style="text-indent: 00em;">Freedom had come to Wannasea</p><br/>
<p style="text-indent: 00em;">Two more times, Abe and the musicians go through the last three refrains. Each time the crowd’s vocalizing grows louder. At the end of the third repetition, Abe wipes his now sweating brow with his handkerchief, turns to the band and says, “I’m through boys. You can take it from here.”</p>
<p style="text-indent: 00em;">The band breaks into Reggie’s musical version of the same island folk story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?64383b9c